module.exports = __webpack_public_path__ + "img/back-careers.d6a41ac9.png";